import React, {useState, useContext} from 'react';
import { Dimensions, View, ScrollView, Switch, Pressable } from 'react-native';
import {
  ChatModal,
  ModalView,
  ModalContainer,
  ModalHeader,
  HeaderText,
  ModalContent,
  CancelX,
} from './elements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXmark, faWindowMinimize } from '@fortawesome/free-solid-svg-icons';
import MessageInputContext from '../../contexts/MessageInputContext';

const Modal = props => {
  const { setCurrentConversationId } = useContext(MessageInputContext);
  const {
    showModal,
    setShowModal,
    modalType,
    children,
    objectName,
    pendingResponse
  } = props;
  const screenHeight = Dimensions.get('window').height - 100
  return (
    <ModalContainer
      // onPress={() => setShowModal(false)}
    >
      {/* <DefaultModal
        visible={showModal}
        transparent={true}
      > */}
        <ChatModal
          onClick={() => false}
          conversationsIndex={true}
        >
          <ModalHeader pendingResponse={pendingResponse}>
            <HeaderText>
              {`${modalType}`}{`${objectName ? ' - ' + objectName : ''}`}
            </HeaderText>
            <View
              style={{display: 'flex', flexDirection: 'row'}}
            >
              <Pressable>
                <CancelX>
                  <FontAwesomeIcon
                    icon={faWindowMinimize}
                    size='lg'
                    style={{color: '#fff', marginRight: '5px'}}
                    onClick={() => setShowModal(false)}
                  />
                </CancelX>
              </Pressable>
              {/* <Pressable>
                <CancelX>
                  <FontAwesomeIcon
                    icon={faSquareXmark}
                    size='lg'
                    style={{color: '#fff', marginLeft: '5px'}}
                    onClick={() => setCurrentConversationId()}
                  />
                </CancelX>
              </Pressable> */}
            </View>
          </ModalHeader>
          <ModalContent>
            <View style={{ height: "auto", maxHeight: screenHeight, flex: 1 }}>
              { children }
            </View>
          </ModalContent>
        </ChatModal>
      {/* </DefaultModal> */}
    </ModalContainer>
  )
}

export default Modal;